import React, { PropsWithChildren } from 'react'

const HiddenSEOContent = ({ children }: PropsWithChildren) => {
  return (
    <div aria-hidden="false" className="visually-hidden">
      {children}
    </div>
  )
}

export default HiddenSEOContent
